<template>
  <button
    class="flex h-8 flex-row items-center rounded border-[0.5px] p-1 2xs:pl-2"
    :class="open || isSomeTypeFilterActive ? 'bg-primary-400 border-indigo-500' : 'bg-grey-35 border-transparent'"
    :aria-expanded="open"
    @click.stop="onToggle()"
  >
    <gv-type
      v-if="!isMobile"
      variant="button"
      uplifted-variant="button"
      text="Filters"
      :class="open || isSomeTypeFilterActive ? 'text-white' : ''"
    />
    <gv-icon v-else name="filter_alt" :class="open || isSomeTypeFilterActive ? 'fill-white' : 'fill-secondary'" aria-hidden="true" />
    <gv-icon-sharp
      v-if="!isMobile"
      :name="open ? 'expand_less' : 'expand_more'"
      :class="open || isSomeTypeFilterActive ? 'fill-white' : ''"
      aria-hidden="true"
    />
  </button>
</template>

<script setup lang="ts">
import { useEventBus } from '@/composables';
import { BREAKPOINTS } from '@/constants/index';
import { ToolbarMode, useHazardsStore, useToolbarStore } from '@/features';
import { useBreakpoints } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller('2xs');
const props = defineProps<{
  setToolbarMode: ToolbarMode;
  dropdownOpen?: boolean;
  toggleOpen?: () => void;
}>();

const { isSomeTypeFilterActive } = storeToRefs(useHazardsStore());
const { toolbarMode } = storeToRefs(useToolbarStore());

const open = computed(() => (props.toggleOpen === undefined ? toolbarMode.value === ToolbarMode.Filters : props.dropdownOpen));

const onToggle = () => {
  if (!props.toggleOpen) toolbarMode.value = toolbarMode.value === props.setToolbarMode ? ToolbarMode.None : props.setToolbarMode;
  else props.toggleOpen();
};

const eventBus = useEventBus();

eventBus.onActionWithParameters('mobile-nav-menu-state', (params) => {
  if (params.value) {
    toolbarMode.value = ToolbarMode.None;
  }
});
</script>
